import React, { CSSProperties } from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Buttons } from '../components' // adapte ce chemin à ton projet

interface Props {
    title: string
    children: React.ReactNode
    classNameWrapper?: string
    style?: CSSProperties
    arrowBack?: boolean
    route?: string
    viewall?: boolean
    action?: string
    actionOnclick?: (event: React.MouseEvent<HTMLButtonElement>) => void
    classBlockHeader?: string
}

const ProcessLayoutV2: React.FC<Props> = ({
    title,
    children,
    classNameWrapper = '',
    style = {},
    arrowBack = false,
    route,
    viewall = false,
    action,
    actionOnclick,
    classBlockHeader = 'justify-content-between'
}) => {
    const { t } = useTranslation()

    return (
        <div className={`d-flex m-none ${classNameWrapper}`} style={style}>
            <div>
                <div className={`d-flex ${classBlockHeader} align-items-center fs-4 mt-4 flex-wrap process-layout-v2-header`}>
                    <div className="d-flex align-items-center">
                        {arrowBack && (
                            <NavLink
                                to={route || ''}
                                className="me-2 text-decoration-none process-layout-v2-link"
                            >
                                <i className="bi bi-arrow-left fs-5"></i>
                            </NavLink>
                        )}
                        <h6 className="m-0">{title}</h6>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        {route && viewall && (
                            <NavLink
                                className="fs-6 text-decoration-none viewall process-layout-v2-link"
                                to={route}
                            >
                                {t('views.processView.viewAll')}
                            </NavLink>
                        )}

                    </div>
                </div>

                <div className="d-flex justify-content-start gap-3 mt-2 flex-wrap">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default ProcessLayoutV2
